const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
const DATE_LENGTH = 4;
const SEQUENCE_LENGTH = 4;
const REFERENCE_LENGTH = DATE_LENGTH + SEQUENCE_LENGTH;

export const normalizeAlertReferencePrefix = value => {
	if (typeof value !== "string") return null;

	let normalized = value.trim().toUpperCase().replace(/[\s-]/g, "");
	if (normalized.startsWith("AL")) {
		normalized = normalized.slice(2);
	}
	normalized = normalized.replace(/O/g, "0").replace(/[IL]/g, "1");

	if (
		normalized.length < 1 ||
		normalized.length > REFERENCE_LENGTH ||
		normalized.split("").some(character => !ALPHABET.includes(character))
	) {
		return null;
	}

	return normalized;
};

export const normalizeAlertReference = value => {
	const normalized = normalizeAlertReferencePrefix(value);
	if (
		!normalized ||
		normalized.length !== REFERENCE_LENGTH ||
		normalized.slice(DATE_LENGTH) === "0".repeat(SEQUENCE_LENGTH)
	) {
		return null;
	}
	return normalized;
};

export const formatAlertReference = value => {
	const normalized = normalizeAlertReference(value);
	return normalized
		? `AL-${normalized.slice(0, DATE_LENGTH)}-${normalized.slice(DATE_LENGTH)}`
		: null;
};

export const isAlertReference = value => Boolean(normalizeAlertReference(value));

export const isAlertReferencePrefix = (value, minimumLength = 4) => {
	const normalized = normalizeAlertReferencePrefix(value);
	if (!normalized || normalized.length < minimumLength) return false;

	const trimmed = value.trim();
	if (/^AL-/i.test(trimmed)) return true;

	// Unprefixed values are ambiguous with ordinary numeric and date searches.
	// Only treat one as a reference search when it is a complete reference.
	return !/^AL/i.test(trimmed) && isAlertReference(value);
};
